import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusClusteringDisplay } from '@/components/StatusClusteringDisplay';
import { VorgangListeItem } from '@/types';
import { VorgangTable } from './VorgangTable';

export const VorgaengePage: React.FC = () => {
  const navigate = useNavigate();

  const handleEdit = (item: VorgangListeItem) => {
    navigate(`/vorgaenge/${item.id}`);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between pt-3">
        <h1 className="text-2xl font-bold text-text-primary">Vorgänge</h1>

        <div className="flex items-center gap-4">
          <StatusClusteringDisplay scope="main" showGesamtBadge={false} />
        </div>
      </div>
      <VorgangTable onEdit={handleEdit} />
    </div>
  );
};
